/**
 * @file: LeadDrawerHeaderButton.tsx
 * @copyright: (c) 2019-2021 sichuan zhichetech co., ltd.
 *
 * The nav-header burger affordance on the lead list. The leads flow is a
 * top-level drawer destination, so tapping it opens the app sidebar — mirroring
 * the dashboard header's hamburger.
 */

import { LD } from '@euler/app/flows/leads/pages/detail/components/leadDetailKit';
import { useResponsiveContext } from '@euler/functions/responsive/ResponsiveContext';
import { DrawerActions, useNavigation } from '@react-navigation/native';
import { Menu } from 'lucide-react-native';
import { memo, useCallback } from 'react';
import { TouchableOpacity } from 'react-native';

export const LeadDrawerHeaderButton = memo(() => {
  const { rpx } = useResponsiveContext();
  const navigation = useNavigation();
  const onPress = useCallback(() => {
    navigation.dispatch(DrawerActions.openDrawer());
  }, [navigation]);
  return (
    <TouchableOpacity
      activeOpacity={0.7}
      onPress={onPress}
      hitSlop={{ top: rpx(10), bottom: rpx(10), left: rpx(10), right: rpx(10) }}
      style={{
        width: rpx(36),
        height: rpx(36),
        marginLeft: rpx(12),
        alignItems: 'center',
        justifyContent: 'center',
      }}
    >
      <Menu size={rpx(22)} color={LD.ink} />
    </TouchableOpacity>
  );
});
